@import '../../../constants/spacing.module.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.container {
  background-color: var(--white);
  border: 2px solid var(--grey-300);

  &:hover {
    background-color: var(--grey-100);
  }

  border-radius: @space-8;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  padding: @space-16;
}

.selected {
  background-color: var(--blue-200);
  border: 2px solid var(--blue-600);

  &:hover {
    background-color: var(--blue-300);
  }
}

.disabled {
  background-color: var(--grey-200);
  cursor: default;

  &:hover {
    background-color: var(--grey-200);
  }

  .title {
    color: var(--grey-600);
  }
}

.title-container {
  display: grid;
  grid-template-columns: auto 1fr;
}

.check {
  place-self: center end;
  color: var(--blue-600);
  height: 18px;
  margin-left: @space-8;
  width: 18px;
}

.description {
  color: var(--grey-600);
  margin-top: @space-8;
}

.additional-content {
  margin-top: @space-24;
}

.centered {
  .title-container {
    grid-template-columns: 1fr auto 1fr;
  }

  .title {
    grid-column-start: 2;
    text-align: center;
  }

  .description,
  .additional-content {
    align-self: center;
  }
}

.read-only {
  cursor: default;

  &:hover {
    background-color: var(--white);
  }
}
